import { useMutation } from "@tanstack/react-query"
import { setTwoFactor } from "@/api"

export const useSetTwoFactor = () => {
  return useMutation({
    mutationFn: (enabled: boolean) => setTwoFactor(enabled),
  })
}
